import React, { ReactElement, ReactNode } from 'react'
import Typography from '../../Atoms/Typography'

import styles from './index.module.css'
import List from './List'

interface IIconTextProps {
  icon: ReactElement
  children: ReactNode
  /**
   * Default: l
   */
  size?: 'xl' | 'l' | 's'
  color?: string
  wrap?: boolean
  bold?: boolean
}

const getTypographyProps = (
  size: IIconTextProps['size'],
  bold?: boolean
): { variant: 'caption' | 'body'; size: 'l' | 'm'; bold?: boolean } => {
  if (size === 'l') return { variant: 'caption', size: 'l', bold }
  if (size === 's') return { variant: 'caption', size: 'm', bold }
  if (size === 'xl') return { variant: 'body', size: 'l', bold: true }

  return { variant: 'caption', size: 'l' }
}

function IconText(props: IIconTextProps) {
  const { icon, children, size = 'l', color, wrap, bold } = props
  const typographyProps = getTypographyProps(size, bold)
  const IconComponent = React.cloneElement(icon, {
    size: icon.props.size ?? 16,
    'data-testid': 'icon-test',
  })

  return (
    <div
      data-testid="icon-text"
      style={{
        ...(color && { color }),
        ...(!wrap && { whiteSpace: 'nowrap' }),
      }}
      className={styles.container}
      data-size={size}
    >
      <span className={styles.icon}>{IconComponent}</span>
      <span>
        <Typography {...typographyProps} as="span">
          {children}
        </Typography>
      </span>
    </div>
  )
}

IconText.List = List

export default IconText
